export default __webpack_public_path__ + "static/media/pets-logo.af8ebd88.svg";